import api from './api';

const statesService = {
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    if (params.countryId) queryParams.append('countryId', params.countryId);

    const response = await api.get(`/state/get-state?${queryParams.toString()}`);
    return {
      states: response.data.data || [],
      pagination: response.data.pagination || null,
    };
  },

  create: async (data) => {
    const response = await api.post('/state/add-state', data);
    return response.data.data || response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/state/update-state/${id}`, data);
    return response.data.data || response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/state/delete-state/${id}`);
    return response.data;
  },
};

export default statesService;
